import { currencyPositiveValidator, currencyValidator } from './currency.validator';
import {
    dateRangeValidator,
    dateValidator,
    maxDateRangeValidator,
    maxDateValidator,
    minDateRangeValidator,
    minDateValidator,
    noFutureDateValidator,
    noPastDateValidator
} from './date.validator';
import { emailValidator } from './email.validator';
import { listValidator } from './list.validator';
import {
    disallowZeroValidator,
    keyValidator,
    lessThanNumberValidator,
    maxNumberValidator,
    minNumberValidator,
    numberRangeValidator,
    numberValidator,
    positiveNumberValidator,
    wholeNumberValidator,
    zeroOrGreaterNumberValidator
} from './number.validator';
import { passwordValidator, strictPasswordValidator } from './password.validator';
import { pathSegmentValidator } from './path-segment.validator';
import { phoneValidator } from './phone.validator';
import { requiredGroupValidator, requiredOneOfValidator } from './required.validator';
import {
    exactLengthValidator,
    fullNameValidator,
    jsonValidator,
    matchValueConfirmValidator,
    matchValueSourceValidator,
    maxLengthValidator,
    minLengthValidator,
    notMatchValueValidator,
    textareaValidator
} from './string.validator';
import { trnoValidator } from './trno.validator';

export class LsqValidators {
    public static currency = currencyValidator;
    public static currencyPositive = currencyPositiveValidator;
    public static date = dateValidator;
    public static dateRange = dateRangeValidator;
    public static noFutureDate = noFutureDateValidator;
    public static noPastDate = noPastDateValidator;
    public static disallowZero = disallowZeroValidator;
    public static email = emailValidator;
    public static exactLength = exactLengthValidator;
    public static list = listValidator;
    public static matchValueSource = matchValueSourceValidator;
    public static matchValueConfirm = matchValueConfirmValidator;
    public static maxDate = maxDateValidator;
    public static json = jsonValidator;
    public static key = keyValidator;
    public static maxDateRange = maxDateRangeValidator;
    public static maxLength = maxLengthValidator;
    public static maxNumber = maxNumberValidator;
    public static minDate = minDateValidator;
    public static minDateRange = minDateRangeValidator;
    public static minLength = minLengthValidator;
    public static minNumber = minNumberValidator;
    public static notMatchValue = notMatchValueValidator;
    public static number = numberValidator;
    public static numberRange = numberRangeValidator;
    public static password = passwordValidator;
    public static strictPassword = strictPasswordValidator;
    public static phone = phoneValidator;
    public static positiveNumber = positiveNumberValidator;
    public static requiredGroup = requiredGroupValidator;
    public static requiredOneOf = requiredOneOfValidator;
    public static textArea = textareaValidator;
    public static fullName = fullNameValidator;
    public static wholeNumber = wholeNumberValidator;
    public static zeroOrGreaterNumber = zeroOrGreaterNumberValidator;
    public static pathSegment = pathSegmentValidator;
    public static lessThanNumber = lessThanNumberValidator;
    public static trnoValidator = trnoValidator;
}
